module.exports = __webpack_public_path__ + "img/violet_017.39e04308.png";